export default "__VITE_ASSET__x_DPtTDD__"